import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

export type RulesPageRuleType = 'AUTO_PRICE' | 'GENERIC_RULE';

const initialState: RulesPageRuleType = 'AUTO_PRICE';

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.type',
  initialState: initialState as RulesPageRuleType,
  reducers: {
    SET_RULES_FILTERS_TYPE: (_state, action: PayloadAction<{ type: RulesPageRuleType }>) => {
      return action.payload.type;
    },
  },
});
export const { SET_RULES_FILTERS_TYPE } = slice.actions;
export const selectorRulesPageFiltersType = (state: RootState) => state.ipa.strategy.rules.filters.type;

export default slice.reducer;
